export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      FunctionInfo: {
        FunctionId: 3,
        FunctionName: 'スマホ連携機能',
        DeliveryType: ' family_info'
      }
    }
  }
}